import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// All auth is via httpOnly cookies (set by backend on /auth/login & /auth/register).
// withCredentials ensures cookies are sent on cross-origin requests.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});
